import { ProductImageURL } from "../../../../components/custom/category/listings/ProductImage";
import { HStack } from "../../../../../styled-system/jsx";
import ExternalProductLink from "../../../../components/custom/merchandise/ExternalProductLink";
import { getURLPrefix } from "../../../../utils/getUrlPrefix";

const URL_PREFIX = getURLPrefix();

interface AsinProductCellProps {
  asin: string;
}

const AsinProductCell = ({ asin }: AsinProductCellProps) => {
  return (
    <HStack gap="xsmall">
      <ProductImageURL url={`${URL_PREFIX}/api/productimage/?asin=${asin}`} width="50px" height="50px" />
      {asin} <ExternalProductLink asin={asin} />
    </HStack>
  );
};

export default AsinProductCell;
